<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <large-base-card>
    <div class="d-flex align-center">
      <div>
        <div class="text-h4 font-weight-bold">
          {{ $t('TaxStatistics') }}
        </div>
        <div
          class="text-body-2 text-subtitle-1"
        >
          {{ $t('TaxStatisticsHint') }}
        </div>
      </div>
      <v-spacer />
      <div
        class="d-flex align-center"
        style="height: 48px;"
      >
        <v-icon>mdi-bank</v-icon>
      </div>
    </div>
    <div
      v-if="info.taxGroupInfo"
      class="text-body-1 mt-4"
    >
      <div class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div>
            {{ $t('AllSales') }}
          </div>
          <div>
            {{ info.total | priceDisplay }}
          </div>
        </div>
        <div class="d-flex justify-space-between mt-1">
          <div>{{ $t('netto') }}/ {{ $t('tax') }}</div>
          <div>{{ info.totalTe| priceDisplay }}/{{ info.totalTax| priceDisplay }}</div>
        </div>
        <v-divider class="my-4" />
      </div>
      <template v-for="(total,index) in taxListInfo">
        <div :key="total.taxRatePercentage+'-'+index">
          <div class="d-flex justify-space-between">
            <div> {{ $t('sales') }} {{ total.taxType }}</div>
            <div class="font-weight-bold">
              {{ total.taxGroupTotal| priceDisplay }}
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div>{{ $t('netto') }}/ {{ $t('tax') }}</div>
            <div>{{ total.nettoumsatz| priceDisplay }} /{{ total.umsatzsteuer| priceDisplay }}</div>
          </div>
          <v-divider
            v-if="index!==taxListInfo.length-1"
            class="my-4"
          />
        </div>
      </template>
    </div>
  </large-base-card>
</template>

<script>

import LargeBaseCard from '@/views/widget/commonDecoration/LargeBaseCard'
import { groupBy } from 'lodash'
import { changeSymbol, getFlattenedArray } from '@/model/dataLayer/service/MultipleStores'

export default {
  components: { LargeBaseCard },
  props: {
    info: {},
    date: {}
  },
  data () {
    return {
      series: []
    }
  },
  computed: {
    taxListInfo () {
      const res = getFlattenedArray(this.info, 'taxGroupInfo')
      const groupInfo = groupBy(res, 'taxRatePercentage')
      return Object.values(groupInfo).map(arr => {
        return arr.reduce((b, c) => {
          b.taxGroupTotal += parseFloat(c.taxGroupTotal)
          b.nettoumsatz += parseFloat(changeSymbol(c.nettoumsatz))
          b.umsatzsteuer += parseFloat(changeSymbol(c.umsatzsteuer))
          b.taxType = c.taxType
          return b
        }, { taxGroupTotal: 0, nettoumsatz: 0, umsatzsteuer: 0 })
      }
      )
    }
  }

}
</script>
